import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAssignInviteToParkingForHost } from '../../hooks/mutation/use-assign-invite-to-parking-for-host';
import { useDetachInviteToParkingForHost } from '../../hooks/mutation/use-detach-invite-to-parking-for-host';

import { Select } from '@/components/atoms/select';
import { Can } from '@/permissions/can';

interface Props {
  hostId: number;
  allowInviteToParking: boolean;
}

const AllowedInviteToParking = ({ hostId, allowInviteToParking }: Props) => {
  const { t } = useTranslation(['common']);

  const { mutate: assignInviteToParkingForHost } = useAssignInviteToParkingForHost();

  const { mutate: detachInviteToParkingForHost } = useDetachInviteToParkingForHost();

  const onSelect = (value: string) => {
    if ((value === 'yes' && allowInviteToParking) || (value === 'no' && !allowInviteToParking)) {
      return;
    }
    if (value === 'no') {
      detachInviteToParkingForHost(hostId);
    } else {
      assignInviteToParkingForHost(hostId);
    }
  };

  return (
    <Can I="allowedInviteToParking" a="Hosts" passThrough>
      {allowed => (
        <Tooltip
          title={t('common:notSufficientPermissions')}
          disableFocusListener={allowed}
          disableHoverListener={allowed}>
          <span>
            <Select
              onClick={onSelect}
              value={allowInviteToParking ? 'yes' : 'no'}
              disabled={!allowed}
              options={[
                { label: t('common:yes'), value: 'yes' },
                { label: t('common:no'), value: 'no' },
              ]}
            />
          </span>
        </Tooltip>
      )}
    </Can>
  );
};

export default AllowedInviteToParking;
